import * as React from "react";
const SvgFilter = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path d="M10 18h4v-2h-4zM3 6v2h18V6zm3 7h12v-2H6z" className="filter_svg__cls-2" data-name="Trazado 169" /></svg>;
export { SvgFilter as ReactComponent };